import { render, staticRenderFns } from "./randeman.vue?vue&type=template&id=3ed8de45&"
import script from "./randeman.vue?vue&type=script&lang=js&"
export * from "./randeman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports